import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'cov-walkme-info',
  imports: [TranslocoPipe],
  templateUrl: './walkme-info.component.html',
  styleUrl: './walkme-info.component.scss',
})
export class WalkmeInfoComponent {}
